import {
    convertUniversalDateToPersianDate, RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoConfirmDialog,
    RaikoCustomSelect,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined,
    showServerErrorMessage, showSuccessMessage,
    RaikoToggleOutlined,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne, raikoCustomSelectItemGenerator, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import React from "react";
import {UserInformationTabTypes} from "../userInfromation/UserInformation";
import TabPanel from "@mui/lab/TabPanel";
import {transactionTypeStatus} from "./CashTransactions";
import {TagService} from "../../serverService/tagService/TagService";
import {CategoryService} from "../../serverService/categoryService/CategoryService";
import {useEffect} from "react";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {MagazineCategoryParser} from "../magazineCategory/MagazineCategoryParser";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {CostAndRevenueService} from "../../serverService/costAndRevenueService/CostAndRevenueService";

export default function CashTransactionDetails() {

    const {fundID} = useAuthState();
    const {id: transactionId} = useParams();
    const tagService = new TagService();
    const categoryService = new CategoryService();
    const service = new CostAndRevenueService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [title, setTitle] = useState("");

    const navigate = useNavigate()
    const [value, setValue] = useState(UserInformationTabTypes.BasicInfo.id);

    function handleChangeTabMenu(event, newValue) {
        setValue(newValue)
    }

    const [statusFilter, setStatusFilter] = useState(transactionTypeStatus.ALL.id);
    const [amount, setAmount] = useState("");
    const [date, setDate] = useState("");
    const [tagList, setTagList] = useState([]);
    const [tagSelectedID, setTagSelectedID] = useState(-1);
    const [categoryInlineItems, setCategoryInlineItems] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
    const [enabled, setEnabled] = useState(true);
    const [description, setDescription] = useState("");
    useEffect(() => {
        getTagListFromServer()
        getCategoryListFromServer()
        getCashTransactionDetailsFromServer()
    }, [fundID]);

    function getTagListFromServer() {

        tagService.getTagList(fundID, 0, 1000000).then(
            response => {

                setTagList([])
                response.data.map((item) => {
                    setTagList(prevState => [...prevState,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })
                console.log("tag list", tagList)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    function getCategoryListFromServer() {
        categoryService.getCategoryList(fundID).then(
            response => {
                const categoryParser = new MagazineCategoryParser(response)
                setCategoryInlineItems(categoryParser.getCategoryListInlineParser())
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    function getCashTransactionDetailsFromServer() {
        loading.show()
        service.getCashTransactionDetails(fundID, transactionId).then(
            response => {
                setTitle(response.title)
                setStatusFilter(response.kind)
                setAmount(response.amount)
                setDate(convertUniversalDateToPersianDate(response.payAt))
                setTagSelectedID(response.tag ? response.tag.id : -1)
                setEnabled(response.enabled)
                setDescription(response.description)
                if (response.categories && response.categories.length > 0)
                    setSelectedCategoryId(response.categories[0].id)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })

    }

    function updateCashTransaction() {
        loading.show()
        service.updateCashTransactionDetails(
            fundID,
            transactionId,
            title,
            statusFilter,
            amount,
            date,
            tagSelectedID,
            enabled,
            description,
            selectedCategoryId).then(
            response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    //delete-cash-transaction
    const [confirmDialog, setConfirmDialog] = useState(false);

    function handleOpenDialog() {
        setConfirmDialog(true)
    }

    function handleCloseDialog() {
        setConfirmDialog(false)
    }

    //delete-cash-transaction

    function deleteCashTransaction() {
        loading.show()
        service.deleteCashTransaction(fundID, transactionId).then(
            response => {
                showSuccessMessage("تراکنش با موفقیت حذف شد.")
                navigate(
                    RouteHelper.CashTransactions.globalUrl,
                    {replace: true}
                )
                handleCloseDialog()
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                cancelAction={handleCloseDialog} openConfirmDialog={confirmDialog} doAction={deleteCashTransaction}
                pageTitle={"حذف تراکنش"}
                warningTitle={"آیا از این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={"حذف تراکنش"}
            />

            <RaikoBaseContainer>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb className={css`flex-grow: 1;
                        gap: .5rem;`} breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.CashTransactions.name,
                            RouteHelper.CashTransactions.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            title,
                            ""
                        ),
                    ]}
                    />
                    <RaikoButtonSecondary
                        label={"بازگشت"}
                        onClick={_ =>
                            navigate(-1)
                        }
                    />
                </RaikoFlexFirstChildGrowOne>
                <TabContext value={value}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                         className={css`
                             border-color: var(--header-border-bottom-color) !important;
                             margin-top: 24px;
                         `}>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={CashTransactionDetailsTabType.BasicInfo.title}
                                value={CashTransactionDetailsTabType.BasicInfo.id}
                            />
                        </TabList>

                    </Box>
                    <TabPanel value={CashTransactionDetailsTabType.BasicInfo.id}>
                        <RaikoGridOneColumn>
                            <RaikoBaseContainer>
                                <RaikoGridOneColumn>
                                    <RaikoBaseCardContainer>
                                        <RaikoSectionContainer
                                            title={"اطلاعات پایه"}
                                            hasActionButton
                                            actionButtonOnclick={updateCashTransaction}
                                        >
                                            <RaikoGridThreeColumn>
                                                <RaikoSimpleInputOutlined
                                                    labelText={"عنوان "}
                                                    value={title}
                                                    setValue={setTitle}
                                                />
                                                <RaikoCustomSelect
                                                    labelText={"نوع تراکنش"}
                                                    setValue={setStatusFilter}
                                                    items={[
                                                        raikoCustomSelectItemGenerator(transactionTypeStatus.COST.id, transactionTypeStatus.COST.name),
                                                        raikoCustomSelectItemGenerator(transactionTypeStatus.REVENUE.id, transactionTypeStatus.REVENUE.name),
                                                    ]}
                                                    value={statusFilter}
                                                />
                                                <RaikoMoneyInputOutlined
                                                    labelText={"مبلغ (ریال)"}
                                                    value={amount}
                                                    setValue={setAmount}/>
                                                <RaikoDatePicker
                                                    label={"تاریخ"}
                                                    date={date}
                                                    setDate={setDate}
                                                />
                                                <RaikoCustomSelect
                                                    labelText={"تگ"}
                                                    setValue={setTagSelectedID}
                                                    items={
                                                        [raikoCustomSelectItemGenerator(-1, "هیچکدام"),
                                                            ...tagList
                                                        ]
                                                    }
                                                    value={tagSelectedID}
                                                />
                                                <RaikoCustomSelect
                                                    labelText={"دسته بندی"}
                                                    setValue={setSelectedCategoryId}
                                                    items={
                                                        [raikoCustomSelectItemGenerator(-1, "هیچکدام"),
                                                            ...categoryInlineItems
                                                        ]
                                                    }
                                                    value={selectedCategoryId}
                                                />
                                            </RaikoGridThreeColumn>
                                            <RaikoToggleOutlined
                                                labelText={"فعال / غیر فعال"}
                                                setChecked={setEnabled}
                                                checked={enabled}
                                            />
                                            <RaikoSimpleMultiLineInputOutlined
                                                labelText={"توضیحات"}
                                                value={description}
                                                setValue={setDescription}
                                            />
                                        </RaikoSectionContainer>
                                    </RaikoBaseCardContainer>
                                </RaikoGridOneColumn>
                            </RaikoBaseContainer>
                            <RaikoGridOneColumn>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"حذف تراکنش"}
                                        hasActionButton={true}
                                        actionButtonTitle={"حذف تراکنش"}
                                        actionButtonOnclick={handleOpenDialog}
                                    >
                                        <RaikoAlert
                                            title={"لطفا قبل از ادامه به نکات زیر توجه فرمایید."}
                                            type={raikoAlertTypes.warning}
                                            description={[
                                                "با اتمام حذف امکان بازیابی آن وجود نخواهد داشت.",
                                                "اطلاعات وام و اقساط از سامانه حذف خواهد شد و تنها اطلاعات پرداخت اقساط باقی خواهد ماند."
                                            ]}
                                        />
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>
                            </RaikoGridOneColumn>
                        </RaikoGridOneColumn>

                    </TabPanel>
                </TabContext>
            </RaikoBaseContainer>
        </>

    )
}
const CashTransactionDetailsTabType = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
}